export const loginStyles = () => ({
  loginForm: {
    width: 'clamp(240px, 75vw, 400px)',
    height: 250,
    padding: '20px',
    marginTop: '10px',
    marginBottom: '150px',
    borderRadius: '10px',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderColor: 'white', // Set the border color to red
    borderWidth: '1px',
    borderStyle: 'solid', // Set the border style to soli
  },

  signupForm: {
    width: 350,
    height: 450,
    padding: '20px',
    marginY: '150px',
    borderRadius: '10px',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
  },

  editForm: {
    width: 350,
    height: 550,
    padding: '20px',
    marginY: '150px',
    marginX: 'auto',
    borderRadius: '10px',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
  },

  inputField: {
    marginY: '8px',
  },
});
